import MuiStepper from "@material-ui/core/Stepper";
import React from "react";
export interface StepperProps {
    /**
     * Set the active step (zero based index).
     * Set to -1 to disable all the steps.
     */
    activeStep?: number;
    /**
     * Two or more `<Step />` components.
     */
    children: React.ReactNode;
}
export function Stepper({ activeStep, children }: StepperProps) {
    return (<MuiStepper activeStep={activeStep} alternativeLabel={true} orientation="horizontal">
            {children}
        </MuiStepper>);
}
